import { PlusCircleOutlined } from '@ant-design/icons'
import ProjectForm from 'app/components/Core/Project/Form'
import Button from 'app/components/UI-Elements/General/Button'
import Restricted from 'app/components/UI-Elements/General/Restricted'
import { RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

const ProjectCreateButton: React.FC = () => {
  const { tButtonTitle } = ToolBox.useString()
  const navigate = useNavigate()
  const {
    modalify: { open, close }
  } = useFeedbacker()

  const onCreateProject = () => {
    open({
      content: <ProjectForm props={{ onSuccess, onCancel: close }} />,
      recordType: RecordType.project,
      action: 'create',
      destroyOnClose: true,
      modalType: 'form'
    })
  }

  const onSuccess = (project: IProject) => {
    close()
    navigate(Routes.Project.member(project.id.toString()).show)
  }

  return (
    <Restricted allowFor={['admin', 'manager', 'member']}>
      <Button
        type="secondary"
        title={tButtonTitle({ recordType: RecordType.project, action: 'create' })}
        onClick={onCreateProject}
        icon={<PlusCircleOutlined />}
      />
    </Restricted>
  )
}

export default ProjectCreateButton
